import GridBackToTop from './grid-back-to-top';

export default GridBackToTop;